import { MainInner } from "@/styles/global";
import { Body, H3, SmallHeading2 } from "@/styles/typography";
import { Link } from "gatsby";
import styled from "styled-components";

const Section = styled.div`
  margin: 48px 0;
`;

const Inner = styled(MainInner)`
  flex-direction: row;
  justify-content: space-between;
  margin-top: 48px;
  margin-bottom: 16px;
`;

const NavigationWrapper = styled.div`
  display: flex;
  gap: 16px;
`;

const NavigationButton = styled.div<{ $disabled: boolean }>`
  cursor: ${({ $disabled }) => ($disabled ? "default" : "pointer")};
  opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};
`;

const Title = styled(H3)`
  color: ${({ theme }) => theme.colors.textBlack};
  scroll-margin-top: 130px;
  margin: 0 8px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    scroll-margin-top: 170px;
  }
`;

const Cards = styled.div`
  overflow: scroll;
  padding: 0px 16px;
  scroll-behavior: smooth;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    padding: 0 88px;
    scroll-snap-type: x mandatory;
    scroll-padding-left: 8px;
  }

  @media screen and (min-width: 1512px) {
    padding: 0 calc(50vw - 756px + 88px);
  }
`;

const Container = styled.div`
  display: flex;
  gap: 8px;
  width: max-content;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    width: unset;
    gap: 16px;
  }
`;

const Card = styled(Link)`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.creme};
  border-radius: 14px;
  overflow: hidden;
  text-decoration: none;
  width: 320px;

  svg {
    transition: transform 0.3s;
  }

  &:hover {
    svg {
      transform: translateX(10px);
    }
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    width: calc(100% / 3);
    flex-direction: row;
  }
`;

const CardTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 24px;
  height: 100%;
  gap: 32px;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-height: 45px;

  div {
    p {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    display: grid;
    gap: 32px;
    align-items: center;
    grid-template-columns: auto max-content;
  }
`;

const CardDate = styled(Body)`
  margin-bottom: 8px;
  color: rgba(0, 0, 0, 0.5);
  font-size: 16px;
`;

const CardReadMoreWrapper = styled.div`
  display: flex;
  margin-top: auto;
  justify-content: space-between;
`;

const CardReadMore = styled(SmallHeading2)`
  color: ${({ theme }) => theme.colors.textBlack};
  width: max-content;
`;

const S = {
  Section,
  Inner,
  NavigationWrapper,
  Title,
  Cards,
  Container,
  NavigationButton,
  Card,
  CardTextWrapper,
  ContentWrapper,
  CardDate,
  CardReadMoreWrapper,
  CardReadMore,
};

export default S;
